import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from 'Components/Home'
import { Redirect, useHistory } from 'react-router'
import SuperAdminGuard from './guards/superAdminGuard'
import Tag from 'Components/Tags'
import RrofileRoutes from './profile'
import { HistoryItems } from 'Components/HistoryItems'

const lazyWithReload = importFn =>
  React.lazy(() =>
    importFn().catch(error => {
      if (
        (error.name === 'ChunkLoadError' ||
          (error.name === 'SyntaxError' && error.message?.includes("Unexpected token '<'"))) &&
        !sessionStorage.getItem('chunkLoadReloaded')
      ) {
        sessionStorage.setItem('chunkLoadReloaded', 'true')
        window.location.reload()
        return new Promise(() => {})
      }
      throw error
    })
  )

const AuctionRoutes = lazyWithReload(() => import('./auction'))
const Products = lazyWithReload(() => import('Components/Products/Show'))
const ReceptionRoutes = lazyWithReload(() => import('./reception'))
const ProductRoutes = lazyWithReload(() => import('./products'))
const UsersRoutes = lazyWithReload(() => import('./users'))
const Category = lazyWithReload(() => import('../Components/Category'))
const ClientRoutes = lazyWithReload(() => import('./clients'))
const PaymentsRoutes = lazyWithReload(() => import('./payments'))
const FastTrackReceptionRoutes = lazyWithReload(() => import('./fastTrackReceptions'))

const DashboardRoutes = () => {
  React.useEffect(() => {
    sessionStorage.removeItem('chunkLoadReloaded')
  }, [])

  return (
    <Switch>
      <React.Suspense fallback={<>Loading...</>}>
        <Route index exact path="/home">
          <Home />
        </Route>
        <Route index exact path="/history-items">
          <HistoryItems />
        </Route>
        <Route path="/reception">
          <ReceptionRoutes />
        </Route>
        <Route path="/product">
          <ProductRoutes />
        </Route>
        <Route exact path="/products">
          <Products />
        </Route>
        <Route path="/auctions">
          <AuctionRoutes />
        </Route>
        <Route path="/category">
          <Category />
        </Route>
        <Route path="/tag">
          <Tag />
        </Route>
        <SuperAdminGuard>
          <Route path="/users">
            <UsersRoutes />
          </Route>
        </SuperAdminGuard>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
        <Route exact path="/profile">
          <RrofileRoutes />
        </Route>
        <Route path="/clients">
          <ClientRoutes />
        </Route>
        <Route path="/payments">
          <PaymentsRoutes />
        </Route>
        <Route path="/fast-track-receptions">
          <FastTrackReceptionRoutes />
        </Route>
      </React.Suspense>
    </Switch>
  )
}

export default DashboardRoutes

export const useAppHistory = useHistory
